module.exports = {
    expressPort: 8000,
    //siteUrl: "http://127.0.0.1:8000/api",
    siteUrl: 'https://api.lectorjuris.com.br/api',
}

